import React from 'react';
import styled from 'styled-components';

const ButtonWrapper = styled.button`
    border: 1px solid var(--main-color);
    border-radius: 0.5rem;
    color: var(--main-color);
    font-size: 1rem;
    padding: 0.5rem 1.5rem;
    transition: 0.25s ease;
    width: ${({width}) => width || 'initial'};

    &:hover {
        background-color: var(--main-color);
        color: #FFF;
    }
`;

const ButtonOutline = ({ label, width, clickFn }) => (
    <ButtonWrapper onClick={clickFn} width={width}>{label}</ButtonWrapper>
);

export default ButtonOutline;